import Raven from 'raven-js';
import React from 'react';
import { render } from 'react-dom';
import Root from './components/root';
import store from './store';

if (!process.env.REACT_APP_SENTRY_DSN) {
  console.warn(`Sentry disabled. REACT_APP_SENTRY_DSN missing`)
} else {
  Raven.config(process.env.REACT_APP_SENTRY_DSN).install();

  // captures "Uncaught Promise Exceptions"
  window.onunhandledrejection = e => {
    console.warn('Unhandled Promise Rejection', e.reason)
    Raven.captureException(e, {
      extra: { unhandledPromise: true }
    })
  };
}

render(
  <Root store={store} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js